// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  background-color: rgba(184, 166, 155, 0.7);
  min-width: 320px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  font-family: 'Montserrat', 'Arial', sans-serif;
  color: white;
  margin: 0 auto;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-rendering: optimizeLegibility;
  position: relative;
  z-index: 0;
}

.background-square {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
  width: 49%;
  height: 17%;
  background-color: rgba(144, 110, 103, 0.7);
  border-bottom-left-radius: 10px;
}

@media screen and (max-width: 1439px) {
  .background-square {
    width: 40%;
  }
}

@media screen and (max-width: 763px) {
  .background-square {
    height: 15%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/App/App.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;EAC9C,YAAY;EACZ,cAAc;EACd,UAAU;EACV,6CAA6C;EAC7C,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".app {\n  background-color: rgba(184, 166, 155, 0.7);\n  min-width: 320px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Montserrat', 'Arial', sans-serif;\n  color: white;\n  margin: 0 auto;\n  padding: 0;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n  text-rendering: optimizeLegibility;\n  position: relative;\n  z-index: 0;\n}\n\n.background-square {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  z-index: -1;\n  width: 49%;\n  height: 17%;\n  background-color: rgba(144, 110, 103, 0.7);\n  border-bottom-left-radius: 10px;\n}\n\n@media screen and (max-width: 1439px) {\n  .background-square {\n    width: 40%;\n  }\n}\n\n@media screen and (max-width: 763px) {\n  .background-square {\n    height: 15%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
